"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processPaymentResponse = void 0;
const sendEmail_1 = require("../sendEmail");
const orders_1 = require("../orders");
const getPaymentGatewayById_1 = require("./getPaymentGatewayById");
const helpers_1 = require("../../helpers");
const agents_1 = require("../agents");
const generateReceipt_1 = require("./generateReceipt");
const processPaymentResponse = async (supabase, request, jose) => {
    const payload = jose.decodeJwt(request.payload);
    const payment_response = payload;
    const payment_request_id = payment_response.userDefined1;
    const { data: updatePaymentRequest, error: paymentRequestError } = await supabase
        .from("payment_requests")
        .update({
        raw_response: payment_response,
        status: payment_response.respCode === "0000" ? "Completed" : "Failed",
    })
        .eq("id", payment_request_id)
        .select(`*`);
    console.log("ERRORS", paymentRequestError);
    if (paymentRequestError) {
        throw new Error(paymentRequestError.message);
    }
    // GET THE ORDER
    let order = (await (0, orders_1.getOrderById)(supabase, updatePaymentRequest[0].order_id));
    const agent = await (0, agents_1.getAgentById)(supabase, order?.agent_id || "");
    const order_line_ids = updatePaymentRequest[0].order_line_ids;
    // IS PAYMENT SUCCESSFUL?
    if (payment_response.respCode === "0000") {
        console.log("######## PAYMENT SUCCESSFUL #########");
        const currency = (0, orders_1.getOrderCurrency)(order);
        console.log("provider_id", updatePaymentRequest[0].payment_provider_id);
        // get the config and fee for the payment gateway
        const gateway = await (0, getPaymentGatewayById_1.getPaymentGatewayById)(supabase, updatePaymentRequest[0].payment_provider_id);
        console.log("GATEWAY", gateway);
        const api_config = gateway.api_config.find((config) => {
            return config.env === "test";
        });
        console.log("api_config", api_config);
        const fee_type = api_config.domestic_country === payment_response.issuerCountry
            ? "Domestic"
            : "International";
        const fee = gateway?.fee_config.filter((f) => f.card === payment_response.channelCode &&
            f.type === fee_type &&
            f.currencies.includes(currency))[0];
        console.log("fee", fee);
        const merchant_fee_charged = payment_response.amount * (fee?.Percentage / 100 || 0);
        await (0, orders_1.addOrderLog)(supabase, {
            type: "PAYMENT",
            order_id: order?.id,
            detail: {
                type: "PAYMENT RECEIVED",
                status: null,
                title: updatePaymentRequest[0].invoice_id,
                message: `Payment Successfully Processed - ${payment_response.currencyCode} ${payment_response.amount} - Fee: ${merchant_fee_charged}`,
            },
        });
        console.log("######## GENERATE RECEIPT #########");
        try {
            // UPDATE THE ORDER LINE IDs
            await (0, generateReceipt_1.generateReceipt)(supabase, order_line_ids, order, agent.credit_card_fees / 100, payment_response.amount, merchant_fee_charged, updatePaymentRequest[0].invoice_id);
        }
        catch (error) {
            console.log("ERROR TRYING TO UPDATE ORDER LINE IDs", error);
        }
        console.log("######## RECEIPT GENERATED #########");
        // Need to check if all order lines are FULLY paid
        // retrieve the updated order
        order = await (0, orders_1.getOrderById)(supabase, updatePaymentRequest[0].order_id);
        if (!order || !order.order_lines)
            throw new Error("Order not found");
        console.log("CHECK IS FULLY PAID");
        const fully_paid = order?.order_lines?.every((ol) => {
            if (!ol.versions)
                return false;
            const latest_version = (0, orders_1.getLatestOrderLineVersion)(ol.versions);
            if (!latest_version)
                return false;
            const line_total = (0, orders_1.getOrderLineTotal)(ol);
            return latest_version?.amount_paid >= line_total;
        });
        console.log("fully_paid", fully_paid);
        if (fully_paid) {
            // update each order line to CONFIRMED_PAID
            for (const order_line of order.order_lines) {
                if (!order_line.versions)
                    continue;
                const latest_version = (0, orders_1.getLatestOrderLineVersion)(order_line.versions);
                if (latest_version) {
                    latest_version.status = helpers_1.OrderLineStatus.CONFIRMED_PAID;
                    await (0, orders_1.updateOrderLineVersion)(supabase, latest_version);
                }
            }
            // UPDATE THE ORDER STATUS TO CONFIRMED
            await (0, orders_1.updateOrderStatus)(supabase, order, "CONFIRMED");
            console.log("######## CREATE BILLS #########");
            // CREATE BILLS FOR ALL SUPPLIERS
            const bills = await (0, orders_1.generateSupplierBills)(supabase, order.id, helpers_1.ADMIN_USER_ID);
            console.log("######## BILLS CREATED #########");
            // SEND PURCHASE ORDERS TO SUPPLIERS
            // EMAIL (GOLF) VOUCHERS TO CLIENT
            for (const order_line of order.order_lines) {
                if (order_line.type !== "GOLF")
                    continue;
                const golf_email_obj = {
                    language_code: "en",
                    template_id: helpers_1.GOLF_VOUCHER,
                    order_id: order.id,
                    order_line_id: order_line.id,
                };
                console.log("GOLF VOUCHER - SENDING EMAIL", golf_email_obj);
                await (0, sendEmail_1.sendEmail)(golf_email_obj);
            }
        }
    }
    return payload;
};
exports.processPaymentResponse = processPaymentResponse;
